// extracted by mini-css-extract-plugin
export default {"dataPoint":"_60zXi___DataPoint-module__dataPoint"};